import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import './index.css';
import App from './App';
import { LocaleProvider } from './i18n/LocaleContext';
import { consumeSessionHandoff } from './config/api';
import { installSessionGuard } from './services/session';
import { installApiErrorTranslator } from './services/apiErrors';

// token 失效时统一退回登录页，避免后台只剩一个没有数据的空壳
installSessionGuard();
// 后端越南语报错在错误出口统一翻译成当前界面语言
installApiErrorTranslator();
// 会员端与后台分域部署，先接住跨域跳转带过来的登录态
consumeSessionHandoff();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LocaleProvider>
    <App />
  </LocaleProvider>
);
